module.exports = __webpack_public_path__ + "img/consult_info1.12ac6e60.png";